// extracted by mini-css-extract-plugin
module.exports = {"open_modal":"MobileCreateProposal_open_modal__3Tsqq","add_icon":"MobileCreateProposal_add_icon__2YE_A"};